module.exports = __webpack_public_path__ + "img/40395819.1f041085.png";